/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { EntityType, IGenericDetailedReportRequestObject } from 'interfaces';
import { httpLegend } from 'services/http.legend';
import { ICustomizedLegendData, InteractionInputDTO } from '../CustomizedReportInterfaces';
import { ILegendDataHelper } from '../CustomizedReportHelper';

export class BinWaferMapLegendDataHelper implements ILegendDataHelper {
  private legendData : any = undefined;

  preferences = {
    summary: {
      calculateCustomSummary: (options:any) => {
        if (this.legendData.legendSummary.length > 0 && this.legendData.legendSummary[0][0][options.name]) {
          options.totalValue = this.legendData.legendSummary[0][0][options.name];
        }
      },
      totalItems: [{
        column: 'Total Die Count',
        name: 'Total Die Count',
        summaryType: 'custom',
        displayFormat: 'Total Die Count: {0}',
        showInColumn: 'Count',
        showInGroupFooter: true,
      }],
    },
    legendKeyExpression: 'die_soft_bin_number',
    selectionEventDefaults: {
      xAxisLabel: 'DIE_ID', // TO DO: YET TO DECIDE 💀
      yAxisLabel: 'CLASS_NAME', // TO DO: YET TO DECIDE 💀
      avoidXWhenGroupingPresent: false,
    },
    defaultGrouping: {
      groupKey: 'wafer_key', // TO DO: YET TO DECIDE 💀
      entityType: ('WAFER' as EntityType), // TO DO: YET TO DECIDE 💀
      columnName: 'key', // TO DO: YET TO DECIDE 💀
    },
    postSelectionInYAxis: false,
    equalNumberOfYsForX: false,
  };

  getPreferences = () => (this.preferences);

  postCombinedEvent = (selectionEventInput: InteractionInputDTO) => {
    return httpLegend.setInteractionData(selectionEventInput);
  };

  setLegendData = (data: ICustomizedLegendData) => {
    this.legendData = data;
  };

  getDetailedGraphLegendData = async (requestObject: IGenericDetailedReportRequestObject, callback: (legendData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    if (requestObject.isSoftBin) {
      this.preferences.legendKeyExpression = 'die_soft_bin_number';
    } else {
      this.preferences.legendKeyExpression = 'die_hard_bin_number';
    }
    data.legend.forEach((legendData:any) => {
      legendData.forEach((legendRow:any) => {
        legendRow.hidden = false;
      });
    });
    this.setLegendData(data);
    callback(data);
  };

  subscribeSelectionEvent = async (requestObject: IGenericDetailedReportRequestObject, callback: (graphData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    this.setLegendData(data);
    callback(data);
  };

  subscribeHidingEvent = async (requestObject: IGenericDetailedReportRequestObject, callback: (graphData: ICustomizedLegendData) => void) => {
    const data = await httpLegend.getLegend(requestObject);
    this.setLegendData(data);
    callback(data);
  };
}
